import { render, staticRenderFns } from "./EvTemplateVehiclePanel.vue?vue&type=template&id=53f656df&scoped=true"
import script from "./EvTemplateVehiclePanel.vue?vue&type=script&lang=js"
export * from "./EvTemplateVehiclePanel.vue?vue&type=script&lang=js"
import style0 from "./EvTemplateVehiclePanel.vue?vue&type=style&index=0&id=53f656df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f656df",
  null
  
)

export default component.exports